<!-- PAGINATOR CONTROL BEFORE -->
<div class="tab-nav-bar" #tabNavBar>
  <div
    class="tab-nav-header-pagination tab-nav-header-pagination-before"
    (click)="handlePagination('before')"
    [class.tab-header-pagination-controls-enabled]="showPaginationControls"
    [class.is-disabled]="disableScrollBefore"
  >
    <span class="icon-left-open"></span>
  </div>

  <!--TABS LISTS -->
  <div class="tabs-container" #tabItemsContainer>
    <div class="tabs-list" #tabItems>
      <div class="tab-links">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <!-- PAGINATOR CONTROL AFTER -->
  <div
    class="tab-nav-header-pagination tab-nav-header-pagination-after"
    (click)="handlePagination('after')"
    [class.tab-header-pagination-controls-enabled]="showPaginationControls"
    [class.is-disabled]="disableScrollAfter"
  >
    <span class="icon-right-open"></span>
  </div>
</div>
